import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
import BannerListTable from "./components/BannerListTable";


const Banners = () => {
    return (
    <div className="px-3 md:px-8 h-auto -mt-24">
      <div className="container mx-auto max-w-full">
        <div className="grid grid-cols-1 px-4 mb-16">
          <DndProvider backend={HTML5Backend}>
            <BannerListTable/>
          </DndProvider>
        </div>
      </div>
    </div>
  )
}

export default Banners;